"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("../styles/LegalComponent.css");
var _reactBootstrap = require("react-bootstrap");
var _Button = require("@ccw-pwa-ui/Button");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
const legalComponent = props => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "legal-screen"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, {
    className: "legal-container"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "link-text",
    headerText: props.headerText
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "create-nav-button-div",
    "data-testid": "Privacy"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "nav-primary",
    title: "Privacy",
    rightIcon: props.rightArrow,
    onClick: props.onCLickPrivacy,
    buttonStyle: {
      width: '100%'
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "create-nav-button-div",
    "data-testid": "Terms of Services"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "nav-primary",
    title: "Terms of Services",
    rightIcon: props.rightArrow,
    onClick: props.onCLickTerms,
    buttonStyle: {
      width: '100%'
    }
  }))))));
};
var _default = exports.default = legalComponent;